import { StoryblokComponent, storyblokEditable } from "gatsby-source-storyblok"
import React from "react"
import { ParallaxProvider } from "react-scroll-parallax"

const Page = ({ blok }: Storyblok.BlokProps<Storyblok.PageContent>) => {
  const blokContentString = JSON.stringify(blok)

  const content =
    blok.body &&
    blok.body.map((childBlok) => (
      <StoryblokComponent blok={childBlok} key={childBlok._uid} />
    ))

  const title = blok.title?.length ? (
    <h1 className="text-5xl text-primary py-8 text-center font-bold tracking-wide">
      {blok.title}
    </h1>
  ) : null

  let pageContent: React.ReactNode = (
    <div
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    >
      {title}
      {content}
    </div>
  )

  if (blokContentString.includes('"component":"parallax_image"')) {
    pageContent = <ParallaxProvider>{pageContent}</ParallaxProvider>
  }

  return pageContent
}

export default Page
